import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
// Pagina servita già prerenderizzata (build/_prerender): i componenti con animazione
// d'ingresso la saltano al primo mount di QUESTA rotta per evitare il blink (vedi src/lib/prerender.js)
window.__PRERENDERED_PATH = container.hasChildNodes() ? window.location.pathname : null;

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
